import { SvgIcon } from "@mui/material"

import { ReactComponent as Roadside } from "./Roadside.svg"

export const RoadsideIcon = (props) => {
    return (
        <SvgIcon component={Roadside} {...props} inheritViewBox />
    )
}